import type { CSSProperties, MouseEventHandler } from 'react';
import type { Feature, FeatureCategory } from '../types/feature';

type TileProps = {
	feature: Feature;
	categories: Record<string, FeatureCategory>;
	onClick?: MouseEventHandler<HTMLDivElement>;
};

export default function Tile({ feature, categories, onClick }: TileProps) {
	const category = feature.primary_category ? categories[feature.primary_category] : undefined;
	const style = category ? ({ '--color': category.color } as CSSProperties) : undefined;

	return (
		<div className="tile tile--image-size-regular tile--action" style={style} aria-haspopup="dialog" role="button" onClick={onClick}>
			<div className="tile__container">
				<header className="tile__header">
					<div className="tile__icon" dangerouslySetInnerHTML={{ __html: feature.icon ?? '' }} />
					<p className="h6" dangerouslySetInnerHTML={{ __html: feature.name }}></p>
				</header>
				<div className="tile__content">
					<p dangerouslySetInnerHTML={{ __html: feature.desc_grid }}></p>
				</div>
				<footer className="tile__footer">{category && <div className="tile__category">{category.title}</div>}</footer>
			</div>
		</div>
	);
}
